// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LoadingError_wrapper__Fu-gM","logo":"LoadingError_logo__2a43s","subhead":"LoadingError_subhead__3vAUd"};